import { Check, Loader2 } from "lucide-react";
import { GENERATION_STEPS } from "../tdsReportsConfig";

export default function TdsReportsProgress({ stepIndex }) {
  if (stepIndex < 0) return null;
  return (
    <section className="tdsr-progress" aria-live="polite" aria-label="Report generation progress">
      <h3 className="tdsr-progress__title">Generating report…</h3>
      <ol className="tdsr-progress__steps">
        {GENERATION_STEPS.map((label, i) => {
          const done = i < stepIndex;
          const active = i === stepIndex;
          return (
            <li
              key={label}
              className={`tdsr-progress__step${done ? " tdsr-progress__step--done" : ""}${
                active ? " tdsr-progress__step--active" : ""
              }`}
            >
              <span className="tdsr-progress__icon" aria-hidden="true">
                {done ? <Check size={14} /> : active ? <Loader2 size={14} className="animate-spin" /> : null}
              </span>
              {label}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
